import { Component, OnInit, Input } from '@angular/core';
import { Guest } from 'app/shared';

@Component({
    selector: 'app-guest-search',
    templateUrl: './guest-search.component.html',
    styleUrls: ['./guest-search.component.scss'],
    standalone: false
})
export class GuestSearchComponent implements OnInit {
  startDate: Date = new Date();
  @Input() guest: Guest;
  constructor() { }

  ngOnInit() {
    this.startDate.setMonth(this.startDate.getMonth() - (12 * 30))
  }

}
